export default __webpack_public_path__ + "static/O0143-4f1364c45428b5e91e8b5180af51c8e8.png";